import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getStudentGoals(payload) {
  return { type: actionTypes.GET_STUDENT_GOALS, payload };
}
export function getStudentGoalsSuccess(payload) {
  return { type: actionTypes.GET_STUDENT_GOALS_SUCCESS, payload: payload };
}

export function getStudentGoalsAndDownload(payload) {
  return { type: actionTypes.GET_STUDENT_GOALS_DOWNLOAD, payload };
}

// Get or create student goals
export function saveStudentGoals(payload) {
  return { type: actionTypes.SAVE_STUDENT_GOALS, payload };
}
export function saveStudentGoalsSuccess(payload) {
  return { type: actionTypes.SAVE_STUDENT_GOALS_SUCCESS, payload: payload };
}